/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'

const ResetPasswordFormSchema = new Schema({
  email: {
    type: 'string',
    format: 'email',
    required: true
  }
})

export default ResetPasswordFormSchema
